import { Button, H2, Body2 } from '../../cdl-react-components/components'

const offline = () => {
    return (
        <div id="offline">
            <H2>Looks like you are Offline!</H2>
            <Body2>
                Discovery Digest cannot serve content without an valid internet connection.<br/>
                Please try again when you are connected to the internet.
            </Body2>
            <Button onClick={window.location.reload.bind(window.location)}>Retry</Button>
        </div>
    )
}

export default offline